import styled from 'styled-components';

const NavigationItemContainer = styled.div`
  padding: 20px 30px 20px 30px;
  position: relative;
  border: 1px solid var(--grey-2);
  border-radius: 4px;
  height: 110px;

  img {
    height: 26px;
    margin-bottom: 20px;
  }

  .blue-arrow {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

  p {
    font-size: var(--font-size-p);
    color: var(--black);
    margin: 0;
  }

  .hoverText {
    display: none;

    p {
      max-width: 95%;
    }
  }

  &:hover {
    border-color: #2270ee;
    cursor: ${({ hasLink }) => (hasLink ? 'pointer' : 'inherit')};

    .default {
      display: none;
    }
    .hoverText {
      display: block;
    }
  }

  @media (min-width: 883px) and (max-width: 1199px) {
    height: 100px;

    .default {
      img {
        margin-bottom: 10px;
      }
    }
  }

  @media (max-width: 767px) {
    height: 62px;
    padding: 0 30px 0 30px;
    display: flex;
    align-items: center;

    .default {
      display: flex;

      p {
        line-height: 30px;
      }

      img {
        margin: 0 15px 0 0;
      }
    }

    &:hover {
      border-color: ${({ hasLink }) => (hasLink ? '#2270ee' : 'var(--grey-2)')};

      .default {
        display: flex;

        .blue-arrow {
          display: block;
          bottom: 23px;
        }
      }
      .hoverText {
        display: none;
      }
    }
  }
`;

export { NavigationItemContainer };
